import { TipoCliente } from './tipocliente';

export class Encuesta{
    constructor(
        public ID:number,
        public DESCRIPCION:string,
        public TipoCliente:TipoCliente,
        public FEC_REG:Date,
        public ESTATUS:boolean,
        public FECHA_MOD:Date,
        public HHMMSS_MOD:Date,
        public CVE_USU_MOD:string,
        public ID_TIPO_CLIENTE:Number,
    ){

    }
}